module.exports = __webpack_public_path__ + "static/media/change-meal-icon.62bc2404.svg";